export default __webpack_public_path__ + "static/media/UsBank.07c6afe2.svg";